<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 3000 !important;"
  >
    <template v-slot:activator="{ props }">
      <div v-bind="props" >
        <slot></slot>
      </div>
    </template>

    <v-form ref="form" data-cy="podMenu-tools-saveFrame-form">
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <span>{{ $t('routes.pod.menuGenerateAudio.missingAudio') }}</span>
          <v-btn icon @click="dialog = false" :aria-label="$t('common.close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="scrollable mt-4 pt-4">
          <div v-if="isExtractingAudio && !successMessage" class="bg-error mb-2">
            {{ $t('routes.pod.menuGenerateAudio.audioAlreadyExtracting') }}
          </div>
          <div v-else>{{ $t('routes.pod.menuGenerateAudio.generateAudioQuestion') }}</div>
          <div v-show="successMessage" class="bg-success">{{ successMessage }}</div>
          <div v-show="errorMessage" class="bg-error">{{ errorMessage }}</div>
          <div v-if="errorTranslatable" class="bg-error">
            {{ $replaceT(errorTranslatable.code, errorTranslatable.params, errorTranslatable.content) }}
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            @click.prevent="generateAudio()"
            :disabled="isExtractingAudio || preventDoubleclick"
            variant="flat"
            color="primary"
            data-cy=""
          >
            {{ $t('routes.pod.menuGenerateAudio.generateAudio') }}
          </v-btn>

          <v-btn variant="text" @click="dialog = false">{{ $t('common.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { usePodStore } from '@/stores/PodStore.js';
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import DialogModel from '@/components/mixin/DialogModel.js';

export default {
  mixins: [DialogActionKeys, DialogModel],
  name: "GenerateAudioDialog",
  props: {
    pod: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      successMessage: "",
      errorMessage: "",
      errorTranslatable: null,

      preventDoubleclick: false,
    };
  },
  watch: {
    dialog(newValue) {
      if (newValue) {
        this.successMessage = '';
        this.errorMessage = '';
      }
    },
  },
  methods: {
    generateAudio: function () {
      this.preventDoubleclick = true;
      this.successMessage = '';
      this.errorMessage = '';

      let self = this;
      let data = {
        id: this.pod.id,
      };

      const podStore = usePodStore();
      podStore.generateAudio(data)
        .then(function () {
          self.successMessage = self.$t('routes.pod.menuGenerateAudio.audioExtractionStarted');
          setTimeout(() => {
            self.preventDoubleclick = false;
          }, 10000);
        })
        .catch(function (error) {
          if (error && error.response && error.response.data && error.response.data.error) {
            const apiError = error.response.data.error.message;
            if (typeof apiError == 'object') {
              self.errorTranslatable = apiError;
            } else {
              self.errorMessage = apiError;
            }
            console.log(error);
          } else {
            self.errorMessage = 'Error!';
          }
          self.preventDoubleclick = false;
        });
    },
  },
  computed: {
    isExtractingAudio: function() {
      if (this.pod && this.pod.launchedServices && this.pod.launchedServices.length > 0) {
        for (let i = 0; i < this.pod.launchedServices.length; i++) {
          if (this.pod.launchedServices[i].code === "AM10") {
            return true;
          }
        }
      }

      return false;
    },
  }
}
</script>
